import CodeError from './CodeError';

class SomethingWentWrongError extends CodeError {
  constructor() {
    const code = 'somethingWentWrong';
    const message = 'Something went wrong';
    super(code, message);
    if ('function' === typeof Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = (new Error(message)).stack;
    }
  }
}

export default SomethingWentWrongError;
